import PropTypes from 'prop-types';
import cx from "ramda-extension/es/cx";
import React, { Component } from 'react';
import Popover from '../../../../atoms/Popover';
import { withDefaultComponentProps } from '../../../../decorators/withDefaultComponentProps';
import capitalizeFirstLetter from '../../../../utils/capitalizeFirstLetter';
import ToastProgressBar from '../ToastProgressBar';
import toastTypes from '../toastTypes';
import { resolveIcon } from '../utils';
const COMPONENT_NAME = 'Toast';
class Toast extends Component {
    constructor(props){
        super(props);
        const { timeout, type } = this.props;
        this.state = {
            progressBar: timeout ? {
                duration: timeout,
                type
            } : null
        };
    }
    componentDidMount() {
        const { timeout, onClose, id } = this.props;
        if (timeout) {
            this.setIntervalId(setTimeout(()=>onClose({
                    id
                }), timeout));
        }
    }
    componentWillUnmount() {
        if (this.intervalId) {
            clearTimeout(this.intervalId);
        }
    }
    setIntervalId(intervalId) {
        this.intervalId = intervalId;
    }
    handleOnMouseEnter() {
        clearTimeout(this.intervalId);
        this.setIntervalId(null);
        this.setState({
            progressBar: null,
            mouseOn: true
        });
    }
    handleOnMouseLeave() {
        const { onClose, timeout, id, type } = this.props;
        const duration = 1000;
        if (timeout) {
            this.setIntervalId(setTimeout(()=>onClose({
                    id
                }), duration));
            this.setState({
                progressBar: {
                    duration,
                    type
                },
                mouseOn: false
            });
        } else {
            this.setState({
                mouseOn: false
            });
        }
    }
    render() {
        const { className, message, title, titleClassName, closeable, onClose, type, iconMapping, renderIcon, id } = this.props;
        const { progressBar, mouseOn } = this.state;
        const typeClassName = type && `Toast--type${capitalizeFirstLetter(type)}`;
        return /*#__PURE__*/ React.createElement("div", {
            className: cx('Toast', mouseOn && 'Toast--hover', typeClassName, className),
            onMouseEnter: this.handleOnMouseEnter.bind(this),
            onMouseLeave: this.handleOnMouseLeave.bind(this)
        }, /*#__PURE__*/ React.createElement(Popover, {
            type: type,
            closeable: closeable,
            onClose: ()=>onClose({
                    id
                }),
            icon: resolveIcon(renderIcon, iconMapping, type)
        }, title && /*#__PURE__*/ React.createElement("p", {
            className: cx('Toast-title', titleClassName)
        }, title), message), /*#__PURE__*/ React.createElement("div", {
            className: "Toast-progress"
        }, progressBar && /*#__PURE__*/ React.createElement(ToastProgressBar, progressBar)));
    }
}
Toast.propTypes = {
    /**
	 * Custom `className` for the root.
	 */ className: PropTypes.string,
    /**
	 * Whether toaster is closable, if true close button will be added
	 */ closeable: PropTypes.bool,
    /**
	 * Function that returns name of icon for given type of toast.
	 *
	 * @param {string} toastType type of toast.
	 * @return {string} iconName
	 */ iconMapping: PropTypes.func,
    /**
	 * Toast unique identifier.
	 */ id: PropTypes.string.isRequired,
    /**
	 * Toast message.
	 */ message: PropTypes.string.isRequired,
    /**
	 * This function is called with id of toast.
	 *
	 * @param {object} Toast to close.
	 * @return {undefined} Nothing
	 */ onClose: PropTypes.func,
    /**
	 * Render icon.
	 */ renderIcon: PropTypes.bool,
    /**
	 * When receive timeout property it shows progressbar and after timeout closes toast.
	 */ timeout: PropTypes.number,
    /**
	 * Title of toast.
	 */ title: PropTypes.string,
    /**
	 * custom className for toast title.
	 */ titleClassName: PropTypes.string,
    /**
	 * Type of toast.
	 */ type: PropTypes.oneOf(toastTypes.values())
};
export { Toast };
export default withDefaultComponentProps(COMPONENT_NAME, {
    renderIcon: true,
    type: toastTypes.INFO
}, Toast);
